<template>
	<div class="text-center acessar-ata-itens botao-tamanho-arp">
		<v-menu offset-y>
			<template #activator="{ on, attrs }">
				<v-btn outlined id="btnHistorico" color="grey" block v-bind="attrs" v-on="on">
					<div v-show="placeholder" class="ml-1 mr-1 texto-botao">
						{{ placeholder }}
					</div>
					<v-icon :size="tamanhoIcone" color="grey">arrow_drop_down</v-icon>
				</v-btn>
			</template>

			<v-list dense>
				<v-list-item-group>
					<v-list-item
						v-for="ata in itensAtaProrrogada"
						:id="ata.id"
						:key="ata.id"
						v-az-auth="ata.authorization"
						:data-testid="ata.evento"
						class="list-item-height"
						@click="$emit(ata.evento, ata.idAta)"
					>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">{{ ata.titulo }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
	</div>
</template>
<script>
import { permissoes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import { mapState } from 'vuex'
import actionTypes from '@/core/constants/action-types'

export default {
	name: 'acessar-ata-itens-btn-historico',
	mixins: [validacaoAta, permissoesMixin],
	data() {
		return {
			tamanhoIcone: '24',
			placeholder: 'HISTÓRICO',
			itensAtaProrrogada: [],
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
	},
	async mounted() {
		await this.buscarInformacoes()
	},
	methods: {
		async buscarInformacoes() {
			const informacoesRetornadas = await this.$store.dispatch(
				actionTypes.ATA.GESTAO_ATA.BUSCAR_ITENS_ATA_BOTAO_HISTORICO,
				{
					idAta: this.informacoesAta.id,
				},
			)
			this.criarItemAtasProrrogada(informacoesRetornadas.itens)
		},
		criarItemAtasProrrogada(informacoesRetornadas) {
			this.itensAtaProrrogada = informacoesRetornadas.map((ata) => {
				return {
					id: ata.id,
					idAta: ata.idAta,
					titulo: ata.descricaoFormatada,
					icone: null,
					evento: 'mudar-ata',
					authorization: permissoes.ataProrrogacaoListar,
				}
			})
		},
	},
}
</script>
<style lang="stylus">
.botao-tamanho-arp .v-btn
	width (116 / 16)rem !important
</style>
